
import { CssBaseline, ThemeProvider } from "@mui/material";
import theme from "./index";
import React from "react";

type props = {
  children: React.ReactNode;
};

const AppThemeProvider: React.FC<props> = ({ children }) => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

export default AppThemeProvider;